<template>
  <div>
    <div class="page-header">
      <h3 class="capitalize">Headnotes</h3>
    </div>
    <TaskExpander />
    <NewQuickTask :new_projects="true"/>

    <ul class="mt-2 list-group">
      <li v-for="task in allTasks" :key="task.id" class="list-group-item js-task-details-collapse-container">
        <QuickTask :task="task" />
      </li>
    </ul>
  </div>
</template>

<script>
import QuickTask from "components/QuickTask";
import NewQuickTask from "components/NewQuickTask";
import TaskExpander from "components/TaskExpander";

export default {
  components: {
    QuickTask,
    NewQuickTask,
    TaskExpander
  },
  computed: {
    allTasks: function(){
      return this.$store.state.tasks.filter(function (task){
        return (task.new_projects == true && task.completed === false)
      })
    }
  }
};
</script>
